interface GroupableMatch {
  mdLabel?: string;
  kickoffAt?: string;
}

const kickoffTime = (match: GroupableMatch): number => {
  const time = match.kickoffAt ? Date.parse(match.kickoffAt) : NaN;
  // Undated matches sort after every dated one in their period.
  return Number.isNaN(time) ? Number.POSITIVE_INFINITY : time;
};

const periodNumber = (label: string): number => parseInt(label.replace(/\D/g, ''), 10) || 0;

/**
 * Group matches by their period label ("GW 3", "MD 1") and order everything
 * oldest-first: periods ascend down the page, and so do the matches inside a
 * period. The results feed arrives newest-first, so without the inner sort a
 * double gameweek would list its later fixture on top.
 */
export function groupMatchesByPeriod<T extends GroupableMatch>(matches: T[]): [string, T[]][] {
  const groups = new Map<string, T[]>();
  for (const match of matches) {
    const key = match.mdLabel || 'Unknown';
    const existingMatches = groups.get(key);
    if (existingMatches) {
      existingMatches.push(match);
    } else {
      groups.set(key, [match]);
    }
  }

  for (const periodMatches of groups.values()) {
    periodMatches.sort((a, b) => kickoffTime(a) - kickoffTime(b));
  }

  return Array.from(groups.entries()).sort((a, b) => periodNumber(a[0]) - periodNumber(b[0]));
}
